/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_DatabaseInputs */

const en_svchip_database = /** @type {(inputs: Svchip_DatabaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Database`)
};

const ar_svchip_database = /** @type {(inputs: Svchip_DatabaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قاعدة البيانات`)
};

const bn_svchip_database = /** @type {(inputs: Svchip_DatabaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডেটাবেস`)
};

const de_svchip_database = /** @type {(inputs: Svchip_DatabaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenbank`)
};

const es_svchip_database = /** @type {(inputs: Svchip_DatabaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base de datos`)
};

const fr_svchip_database = /** @type {(inputs: Svchip_DatabaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base de données`)
};

const pt_svchip_database = /** @type {(inputs: Svchip_DatabaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banco de dados`)
};

const zh_svchip_database = /** @type {(inputs: Svchip_DatabaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数据库`)
};

const tr_svchip_database = /** @type {(inputs: Svchip_DatabaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veritabanı`)
};

const ru_svchip_database = /** @type {(inputs: Svchip_DatabaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`База данных`)
};

const pl_svchip_database = /** @type {(inputs: Svchip_DatabaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baza danych`)
};

/**
* | output |
* | --- |
* | "Database" |
*
* @param {Svchip_DatabaseInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_database = /** @type {((inputs?: Svchip_DatabaseInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_DatabaseInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_database(inputs)
	if (locale === "bn") return bn_svchip_database(inputs)
	if (locale === "de") return de_svchip_database(inputs)
	if (locale === "es") return es_svchip_database(inputs)
	if (locale === "fr") return fr_svchip_database(inputs)
	if (locale === "pt") return pt_svchip_database(inputs)
	if (locale === "zh") return zh_svchip_database(inputs)
	if (locale === "tr") return tr_svchip_database(inputs)
	if (locale === "ru") return ru_svchip_database(inputs)
	if (locale === "pl") return pl_svchip_database(inputs)
	return en_svchip_database(inputs)
});